import {
  http
} from '../../config';
import base from '../base';

export const statisticPage={
  getStatisticList(data){
    return http({
      url:`${base.users}/teacherProxy/queryStatisticsPageList`,
      method:'post',
      data,
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/agent-api/StatisticPage.js